var map = {
	"./symbol_0.png": "8962",
	"./symbol_1.png": "d7f9",
	"./symbol_10.png": "f7f1",
	"./symbol_11.png": "8c1d",
	"./symbol_12.png": "1d03",
	"./symbol_13.png": "08dd",
	"./symbol_2.png": "8fc5",
	"./symbol_3.png": "b951",
	"./symbol_4.png": "7b2c",
	"./symbol_5.png": "1f62",
	"./symbol_6.png": "74c2",
	"./symbol_7.png": "5b32",
	"./symbol_8.png": "a861",
	"./symbol_9.png": "127b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1cb2";